import { gql } from 'apollo-angular';

export const LANGUAGE_LIST = gql`
  query GetAllLanguagesList {
    getAllLanguagesList {
      data {
        languageId
        languageName
        languageCode
        nativeLanguage
      }
      isSuccess
      message
      errorCode
      __typename
    }
  }
`;
